import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, createEntry } from 'store/data/entries';

type HandlerInput = Parameters<typeof createEntry>;

export function useCreateEntry(): Operation<(...input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.CREATE_ENTRY);

	function handler(...input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(createEntry(...input));
	}

	return [{ loading, error }, handler];
}
